import { AppTypographyOptions, AppThemeOptions } from '../IMaterial';

export const initializeTypography = (
  config?: AppThemeOptions['typography']
): AppTypographyOptions => {
  return {
    ...config,
  };
};
